import React from 'react';
import {createRoot} from 'react-dom/client';
import './styles/app.css';
import Authentication from "./components/authentication/authentication";
import './app.less';
import AuthService from "./services/auth.service";
import CampaignService from "./services/campaign.service";
import RegimeForm from "./components/regime_form/regimeForm";
import {
    createBrowserRouter, createRoutesFromChildren, matchRoutes, RouterProvider, useLocation, useNavigationType,
} from "react-router-dom";
import SubscriptionPackage from "./components/subscription_package/subscriptionPackage";
import Panel from "./components/panel/panel";
import UserMeal from "./components/panel/user_meal/userMeal";
import Valley from "./components/valley/valley";
import axios from "axios";
import {toast} from "react-toastify";
import * as serviceWorker from './serviceWorker';
import NewWeight from "./components/panel/new_weight/newWeight";
import PageNotFound from "./components/errors/PageNotFound";
import VoucherService from "./services/voucher.service";
import NewForm from "./components/new_form/newForm";
import Landing from "./components/landing/landing";
// import * as Sentry from "@sentry/react";
// try {
//     Sentry.init({
//         dsn: process.env.SENTRY_REACT_DSN,
//         replaysOnErrorSampleRate: 1.0,
//         replaysSessionSampleRate: 0.1,
//         tracesSampleRate: 1.0,
//         integrations: [
//             new Sentry.Replay({
//                 maskAllText: false,
//                 maskAllInputs: false,
//                 blockAllMedia: false,
//             }),
//             new Sentry.BrowserTracing({
//                 routingInstrumentation: Sentry.reactRouterV6Instrumentation(
//                     React.useEffect,
//                     useLocation,
//                     useNavigationType,
//                     createRoutesFromChildren,
//                     matchRoutes
//                 ),
//             }),
//         ],
//     });
// } catch (exception) {
//
// }

const container = document.getElementById('root');
const root = createRoot(container);
const urlParams = new URLSearchParams(window.location.search);
const lastPartUrl = window.location.href.split("/").pop();
if (urlParams.get('weight') && urlParams.get('weight').length > 0) {
    const queryParams = [
        {name: 'weight', value:urlParams.get('weight')},
        {name: 'height', value:urlParams.get('heigh')},
        {name: 'gender', value:urlParams.get('gender')},
        {name: 'age', value:urlParams.get('age')},
    ];
    localStorage.setItem('regime_form_old', JSON.stringify(queryParams));
}

CampaignService.init();
VoucherService.init();

const APP_URL = process.env.APP_URL;

const router = createBrowserRouter([
    {
        path: "/dashboard", element: <Panel component='dashboard'/>,
    },
    {
        path: "/regime-form", element: <RegimeForm/>,
    },
    {
        path: "/new-form", element: <NewForm/>,
    },
    {
        path: 'auth', element: <Authentication/>
    },
    {
        path: 'subscription-packages', element: <SubscriptionPackage/>
    },
    {
        path: 'subscriptions', element: <Panel component='subscriptions'/>
    },
    {
        path: 'calorie-counter', element: <Panel component='calorie-counter'/>
    },
    {
        path: 'user-meals/:id', element: <Panel component='subscriptions'/>
    },
    {
        path: 'subscriptions/active-subscription', element: <Panel component='active-subscription'/>
    },
    {
        path: 'subscriptions/:subscriptionId/periods/:periodId', element: <Panel component='user-meal'/>
    },
    {
        path: '/', element: <Panel/>
    },
    {
        path: '/weighing', element: <NewWeight/>
    },
    {
        path: '/PageNotFound', element: <PageNotFound/>
    },
    {
        path: '/landing', element: <Landing/>
    },
    {
        path: '/*', element: <PageNotFound/>
    },
]);
if (urlParams.get('token')) {
    root.render(<Valley message={'ورود خودکار ...'}/>);

    let body = {
        token: urlParams.get('token'),
    }

    const campaignParameters = CampaignService.get();

    body = {...body, ...campaignParameters}

    axios.post(`${APP_URL}/api/authentication/login`, body, {})
        .then(function (response) {
            setTimeout(() => {
                if (response.data.user && response.data.access_token && response.data.status) {
                    AuthService.logout();
                    AuthService.successAuth(response.data);
                    window.location.replace('/');
                } else {
                    checkAuth();
                }
            }, 1200);
        })
        .catch(function (error) {
            checkAuth();
        });
} else if (urlParams.get('sso-payload')) {
    root.render(<Valley message={'ورود خودکار ...'}/>);

    axios.post(`${APP_URL}/api/authentication/sso`, {'sso-payload': urlParams.get('sso-payload')}, {})
        .then(function (response) {
            setTimeout(() => {
                if (response.data.user && response.data.access_token && response.data.status) {
                    AuthService.logout();
                    AuthService.successAuth(response.data);
                    window.location.replace(response.data.intent);
                } else {
                    checkAuth();
                }
            }, 1200);
        })
        .catch(function (error) {
            checkAuth();
        });
} else if (lastPartUrl.includes('new-form')){
    setTimeout(() => {
        root.render(<React.StrictMode>
            <RouterProvider router={router}/>
        </React.StrictMode>);
    }, 1200);
}else if (lastPartUrl.includes('landing')){
    setTimeout(() => {
        root.render(<React.StrictMode>
            <RouterProvider router={router}/>
        </React.StrictMode>);
    }, 1200);
} else {
    checkAuth();
}

function checkAuth() {
    if (AuthService.getAccessToken()) {
        root.render(<Valley/>);
        axios.get(`${APP_URL}/api/v3/users`, {
            headers: {
                Authorization: `Bearer ${AuthService.getAccessToken()}`,
                channel: sessionStorage.getItem('channel')
            }
        })
            .then(function (response) {
                localStorage.setItem('auth', JSON.stringify(response.data.data));
                localStorage.setItem('layouts', JSON.stringify(response.data.layouts));

                setTimeout(() => {
                    root.render(<React.StrictMode>
                        <RouterProvider router={router}/>
                    </React.StrictMode>);
                }, 1200);
            })
            .catch(function (error) {
                if (!error.response) {
                    _handleErrorPage();
                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        const {errors} = error.response.data;

                        for (const errorsKey in errors) {
                            const error = errors[errorsKey][0];

                            toast.error(error, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        break;

                    case 401:
                        AuthService.logout();
                        window.location.replace('/');
                        break;
                    default:
                        _handleErrorPage();
                        break;
                }
            });
    } else {
        _handlePage();
    }
}

function _handlePage() {
    const err = localStorage.getItem("error");
    if (err) {
        root.render(<PageNotFound/>);
    } else {
        root.render(<Authentication/>);
     }
}

function _handleErrorPage() {
    root.render(<PageNotFound/>);
}

serviceWorker.register();
